<div class="main-slider" [style.height]="minHeight">
    <div #elm class="slider slider-{{ UID }}">
        @for (slide of slidesList; track slide; let i = $index) {
            <div class="slider-cell slider-cell-{{ i }}" [ngClass]="sliderClasses">
                <ng-template [ngTemplateOutlet]="slide.innerTemplate"></ng-template>
            </div>
        }
    </div>
</div>
